import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="relative overflow-hidden bg-noir-950 py-14 sm:py-24 lg:py-28" data-id="element-109" data-mp="4vs0rz0u8fre">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-600/10 blur-[120px]" data-id="element-110" data-mp="9tl5soqen3q3" />
      <div className="container relative" data-id="element-111" data-mp="jrr3eu56hnp5">
        <motion.div initial={{
        opacity: 0,
        y: 34,
        rotateX: 8
      }} whileInView={{
        opacity: 1,
        y: 0,
        rotateX: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto max-w-3xl rounded-3xl border border-gold-500/30 bg-noir-800/80 p-6 text-center sm:p-12" data-id="element-112" data-mp="nu4bvqbb7zpm">
          <motion.span initial={{
          scale: 0.85,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-gold-500/12 ring-1 ring-gold-500/40 sm:mb-7 sm:h-20 sm:w-20" data-id="element-113" data-mp="12gxi862upv5o">
            <ShieldCheck className="h-8 w-8 text-gold-400 sm:h-9 sm:w-9" aria-hidden="true" data-id="element-114" data-mp="1vvkeln6cqc36" />
          </motion.span>

          <p className="text-[11px] font-bold uppercase tracking-widest2 text-gold-400" data-id="element-115" data-mp="2oi57wt6e0y9d">
            Garantía
          </p>
          <h2 className="mt-3.5 font-display text-[1.7rem] font-bold leading-tight text-cream sm:mt-4 sm:text-4xl" data-id="element-116" data-mp="2jkd4b1wdrnpc">
            Garantía de 30 Días — Sin Preguntas
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-cream/65 sm:mt-6 sm:text-base" data-id="element-117" data-mp="2arjmawpjua7s">
            Lee los 5 libros. Aplica lo que aprendes. Si en los próximos 30 días no
            sientes que valieron cada centavo, te devolvemos el dinero completo.
          </p>

          <div className="mx-auto mt-6 flex max-w-md flex-wrap items-center justify-center gap-2 sm:mt-8 sm:gap-2.5" data-id="element-118" data-mp="10kxgrz2tf1yf">
            {['Sin preguntas', 'Sin procesos complicados', 'Sin drama'].map(item => <span key={item} className="rounded-full border border-cream/12 bg-noir-700/70 px-3.5 py-1.5 text-[11px] font-medium text-cream/70 sm:px-4 sm:py-2 sm:text-xs" data-id="element-119" data-mp="qvduskjt2rzc">
                {item}
              </span>)}
          </div>

          <p className="mx-auto mt-7 max-w-xl border-t border-gold-500/15 pt-5 text-sm leading-relaxed text-cream/55 sm:mt-9 sm:pt-7" data-id="element-120" data-mp="msz9ltsnzg4w">
            <span className="font-semibold text-cream/80" data-id="element-121" data-mp="7x9wym9dcfcu">
              ¿Por qué ofrecemos esto?
            </span>{' '}
            Porque sabemos lo que hay dentro. Y sabemos que funciona.
          </p>
        </motion.div>
      </div>
    </section>;
}